require('slick-carousel');

class smRoutingFormPage {
  constructor() {

  }

  init() {
    //this.hello();
    //this._initProcessSlider();
  }

  hello() {
    console.log('smRoutingFormPage says hello');
  }

  _initProcessSlider = () => {
    let processCarousel = $('#heroCarousel').slick({
      autoplay: true,
      autoplaySpeed: 2800,
      pauseOnFocus: true,
      pauseOnHover: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      dots: false,
      adaptiveHeight: true
    });
  };
}

const smRoutingFormPageInstance = new smRoutingFormPage();
smRoutingFormPageInstance.init();


